import { durationToHours, useAssociateContext } from '@amzn/atoz-shiftapp-utilities';
import { useEffect, useState } from 'react';
export var useWeeklySummaryFeature = function (_a) {
    var maxDuration = _a.maxDuration;
    var features = useAssociateContext().features;
    var _b = useState(null), persistedMaxDuration = _b[0], setPersistedMaxDuration = _b[1];
    useEffect(function () {
        if (maxDuration) {
            setPersistedMaxDuration(maxDuration);
        }
    }, [maxDuration]);
    if (!persistedMaxDuration) {
        return false;
    }
    var maxHours = persistedMaxDuration && durationToHours(persistedMaxDuration.value);
    return ((!!maxHours && maxHours > 0) || features.canAccessLocationEligibility);
};
